export const userStates = {
  home: 'app.user-home',
  chat: 'app.user-conversations',
  feed: 'app.user-activity',
};



// WEBPACK FOOTER //
// ./src/js/user/router-config.js